import React from 'react';
import { styled } from '@linaria/react';

interface Props {
  width: number;
  height: number;
  borderWidth: number;
}

function AngleBackground({ width, height, borderWidth }: Props) {
  // The width/height are from the container, and will include
  // the border applied to the wrapper. Subtract that width to
  // get an accurate inner size.
  const trueWidth = width - borderWidth * 2;
  const trueHeight = height - borderWidth * 2;

  const radius = trueWidth / 2;

  const innerRingRadiuses = [
    radius * 0.8,
    radius * 0.6,
    radius * 0.4,
    radius * 0.2,
  ];

  return (
    <Svg style={{ '--border-width': borderWidth + 'px' }}>
      <Axis
        x1={0}
        y1={trueHeight / 2}
        x2={trueWidth}
        y2={trueHeight / 2}
      />
      <Axis
        x1={trueWidth / 2}
        y1={0}
        x2={trueWidth / 2}
        y2={trueHeight}
      />
      {innerRingRadiuses.map((innerRadius, index) => (
        <circle
          key={index}
          cx={radius}
          cy={radius}
          r={innerRadius}
          fill="none"
          stroke="var(--color-gray-200)"
          strokeWidth={2}
          strokeDasharray="0, 6"
          strokeLinecap="round"
        />
      ))}
    </Svg>
  );
}

const Svg = styled.svg`
  display: block;
  overflow: visible;
  width: 100%;
  height: 100%;
  border: var(--border-width) solid var(--color-gray-300);
  border-radius: 50%;
  overflow: hidden;
`;

const Axis = styled.line`
  stroke: var(--color-gray-200);
  stroke-width: 2px;
`;

export default React.memo(AngleBackground);
